import React, { useState } from 'react';
import { Search, Eraser } from 'lucide-react';
import SelectField from '../../Forms/Input/SelectField';
import ActionButton from '../../Buttons/ActionButton';
import { NegativeStockReportFilters as FiltersType } from '../../../services/inventory/NegativeStockReportService';

interface BranchOption {
  id: number;
  name: string;
}

interface CategoryOption {
  id: number;
  name: string;
}

interface GroupOption {
  id: number;
  name: string;
}

interface Props {
  branches: BranchOption[];
  categories: CategoryOption[];
  groups: GroupOption[];
  onSearch: (filters: FiltersType) => void;
  onReset: () => void;
}

const NegativeStockFilters: React.FC<Props> = ({
  branches,
  categories,
  groups,
  onSearch,
  onReset,
}) => {
  const [branchId, setBranchId] = useState<string | number>('');
  const [categoryId, setCategoryId] = useState<string | number>('');
  const [groupId, setGroupId] = useState<string | number>('');

  const handleSearch = () => {
    onSearch({
      branchId: branchId ? Number(branchId) : undefined,
      categoryId: categoryId ? Number(categoryId) : undefined,
      groupId: groupId ? Number(groupId) : undefined,
    });
  };

  const handleReset = () => {
    setBranchId('');
    setCategoryId('');
    setGroupId('');
    onReset();
  };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      <SelectField
        label="Sucursal"
        name="branchId"
        value={branchId}
        onChange={(e) => setBranchId(e.target.value)}
        options={[
          { value: '', label: 'Todas' },
          ...branches.map((b) => ({ value: b.id, label: b.name })),
        ]}
        iconKey="branch"
      />

      <SelectField
        label="Categoría"
        name="categoryId"
        value={categoryId}
        onChange={(e) => setCategoryId(e.target.value)}
        options={[
          { value: '', label: 'Todas' },
          ...categories.map((c) => ({ value: c.id, label: c.name })),
        ]}
        iconKey="category"
      />

      <SelectField
        label="Grupo de Productos"
        name="groupId"
        value={groupId}
        onChange={(e) => setGroupId(e.target.value)}
        options={[
          { value: '', label: 'Todos' },
          ...groups.map((g) => ({ value: g.id, label: g.name })),
        ]}
        iconKey="search"
      />

      <div>
        <label className="mb-2.5 block select-none text-sm font-medium text-transparent">
          Acción
        </label>
        <div className="flex gap-2">
          <ActionButton
            label="Buscar"
            icon={<Search className="h-4 w-4" />}
            className="h-[50px]"
            onClick={handleSearch}
          />
          <ActionButton
            label="Limpiar"
            variant="secondary"
            icon={<Eraser className="h-4 w-4" />}
            className="h-[50px]"
            onClick={handleReset}
          />
        </div>
      </div>
    </div>
  );
};

export default NegativeStockFilters;
